import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import AdditionalDocuments from 'components/orders/AdditionalOptions/AdditionalDocuments';
import { useTranslation } from 'react-i18next';
import { Link as LinkButton } from '@ontruck/orc';
import { ManifestIcon } from 'refactored/ui/icons';
import { STATUS_WHERE_USER_CAN_ADD_DOCUMENTS } from 'utils/order/constants';
import useDownloadControlDocument, {
  isControlDocumentAvailable,
} from 'hooks/useDownloadControlDocument';

const MRAdditionalOptions = ({ className, order }) => {
  const { t } = useTranslation('OrdersOrderDetail');

  const { downloadControlDocument } = useDownloadControlDocument();

  const canAddDocuments = useMemo(
    () =>
      STATUS_WHERE_USER_CAN_ADD_DOCUMENTS.includes(order?.status) ||
      order?.additional_documents?.length > 0,
    [order]
  );
  const hasControlDocument = isControlDocumentAvailable(order);

  if (!canAddDocuments && !hasControlDocument) {
    return null;
  }

  return (
    <div className={className} data-testid="mr-additional-options">
      <h3 className="title">{t('MR_additional_documents_title')}</h3>
      <p className="subtitle">{t('MR_additional_documents_sub_title')}</p>
      <AdditionalDocuments
        orderId={order?.id}
        documents={order?.additional_documents}
        orderStatus={order?.status}
      />
      {hasControlDocument && (
        <button
          type="button"
          className="download-deca"
          data-testid="download-deca"
          onClick={() => downloadControlDocument(order?.id)}
        >
          <ManifestIcon className="icon" />
          <LinkButton text={t('download_deca')} size="L" />
        </button>
      )}
    </div>
  );
};

MRAdditionalOptions.propTypes = {
  className: PropTypes.string,
  order: PropTypes.object.isRequired,
};
export default MRAdditionalOptions;
